

    export const PreglediGridColumns = [
    { name: "ID", label: "Број", field: "ID", align: "center" },
    { name: "PartnerID", label: "Фирма", field: "PartnerID", align: "left", sortable: true },
    { name: "Baratel", label: "Барател", field: "Baratel", align: "left" },
    { name: "Opis", label: "Опис", field: "Opis", align: "left" },
    { name: "Datum", label: "Датум", field: "Datum", align: "center" },
    { name: "AplikacijaID", label: "Апликација", field: "AplikacijaID", align: "center" },
    { name: "StepenItnost", label: "Итност", field: "StepenItnost", align: "center" },
    { name: "StatusID", label: "Статус", field: "StatusID", align: "center" },
    { name: "Files", label: "Документи", field: "Files", align: "center" },
    { name: "akcii", label: "Акции", align: "center" },
  ];

  export const FaziColumns = [
    // РЕД 1 (како во формата)
    { name: "faza", label: "Фаза", field: "fazaOpis", align: "center" },
    { name: "predal", label: "Предал", field: "predal", align: "center" },
    { name: "primil", label: "Примил", field: "primil", align: "center" },
    { name: "predvidenDatum", label: "Предвиден датум", field: "predvidenDatum", align: "center" },
    { name: "predvidenoVreme", label: "Предвидено време", field: "predvidenoVreme", align: "center" },
  
    // РЕД 2 (како во формата)
    { name: "start", label: "Почеток", field: "start", align: "center" },
    { name: "end", label: "Крај", field: "end", align: "center" },
    { name: "casovi", label: "Часови", field: "casovi", align: "center" },
    { name: "efektivno", label: "Ефективно", field: "efektivno", align: "center" },
  
    // РЕД 3 (Забелешка)
    { name: "zabeleska", label: "Забелешка", field: "zabeleska", align: "left" },
  
    // Акции
    { name: "akcija", label: "Акции", align: "center" }
  ];
  